import { render, staticRenderFns } from "./posVisited.vue?vue&type=template&id=79a93774&"
import script from "./posVisited.vue?vue&type=script&lang=js&"
export * from "./posVisited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports